<template>
  <div
    :class="{'v-btn--disabled':disabled}"
    @click="$refs.file.click()"
    class="v-btn theme--light picker"
    v-ripple
  >
    <input
      :accept="accept"
      @change="pickFiles"
      ref="file"
      style="display: none"
      type="file"
      v-if="!multiple"
    >
    <input
      :accept="accept"
      @change="pickFiles"
      multiple
      ref="file"
      style="display: none"
      type="file"
      v-else
    >
    {{title}}
  </div>
</template>
<script>
import { Ripple } from 'vuetify/es5/directives'
export default {
  props: {
    title: { type: String },
    accept: { type: String },
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  directives: { Ripple },
  data() {
    return {}
  },
  methods: {
    pickFiles(e) {
      console.log(e.target.files)
      if (e.target.files.length === 0) return
      let files = [...e.target.files].map(f => ({
        name: f.name,
        file: f,
        size: f.size,
        type: f.type,
        loaded: 0
      }))
      this.$emit('input', files)
      event.target.value = ''
    }
  }
}
</script>
<style scoped>
.picker.disabled {
  background: #666;
}
</style>
